(ns web3.queries.asset
  (:require [cljs.spec.alpha :as s]
            [x-vec.graphql :as x]
            [web3.persistence.queries :as q]
            [web3.log :as log]))

(declare UUID! ContentCategory Boolean String!
         String Int query fragment mutation
         Boolean! URL URL! ContentCategory! ID ID!
         RecallStatus!)

;; Asset fragments

(x/def ^fragment asset-group-alert-fields {:on :AssetGroup}
  q/entity-id-fields
  [:assets
   q/entity-id-fields
   :alertStatus
   [:recalls q/entity-id-fields]])

(x/def ^fragment asset-group-name-fields {:on :AssetGroup}
  q/entity-id-fields
  :name
  :createdAt
  :sample)


(x/def ^fragment recall-fields {:on :Recall}
  q/entity-id-fields
  :title
  :description
  :status                                                   ;; notified, confirmed, rejected, snoozed
  :match
  :url)

(x/def ^fragment asset-alert-fields {:on :Asset}
  :alertStatus
  :rejectionCode
  [:recalls
   recall-fields])

(x/def ^fragment manufacturer {:on :Asset}
  [:manufacturer {:gql/alias-of :manufacturerName}])

(x/def ^fragment asset-fields {:on :Asset}
  q/entity-id-fields
  :nickname
  manufacturer
  :serialNumber
  :modelNumber
  :sample
  :createdAt
  :tagName
  asset-alert-fields
  [:tag
   q/entity-id-fields
   :name
   :homeAdvisorLink]
  [:model
   [:encompassData :productCount :modelPageLink]
   :manufacturerSupportPhone
   :manufacturerSupportWebsite
   [:tags :homeAdvisorLink]]
  [:primaryImage (q/image-link)]
  [:thumbnailImage {:gql/alias-of :primaryImage}
   (q/thumbnail-link)]
  [:parent
   [:... {:on :AssetGroup}
    asset-group-name-fields]])

(x/def ^fragment content-fields {:on :Content}
  q/entity-id-fields
  :title
  :description
  :link
  :category
  :curated
  :mediaType
  :createdAt
  (q/thumbnail-link :as :thumbnailLink)
  (q/image-link :as :imageLink)
  [:parent
   q/entity-id-fields
   [:... {:on :AssetGroup}
    asset-group-name-fields]
   [:... {:on :Asset}
    :sample]])

(x/defn ^query entity-content-recursive [{:keys [^UUID! id
                                                 ^ContentCategory category
                                                 ^Boolean curated
                                                 ^String! typeName]}]
  [:entity {:gql/alias-of :lookupEntity
            :typeName typeName
            :uuid id}
   [:... {:on :Contented}
    q/entity-id-fields
    [:contents
     {:recursive true
      :category category
      :curated curated}
     content-fields]]])

(x/defn ^query entity-content-simple [{:keys [^UUID! id
                                              ^String! typeName]}]
  ;; entity content query _without_ parameters
  ;; (better to avoid `contents` params when possible, helps with normalization)
  [:entity {:gql/alias-of :lookupEntity
            :typeName typeName
            :uuid id}
   [:... {:on :Contented}
    q/entity-id-fields
    [:contents content-fields]]])

(x/def ^fragment form-data-fields {:on :FormDataUploadMutationPayload}
  :formData
  :formDataFileUriPath
  :headers
  :method
  :url)

(x/defn ^mutation generate-form-data-upload! [{:keys [^String md5
                                                      ^String! mediaType
                                                      ^Int size]}]
  [:generateFormDataUpload
   {:md5 md5
    :mediaType mediaType
    :size size}
   form-data-fields])

(x/defn ^query content [{:keys [^UUID! id]}]
  [:entity {:gql/alias-of :lookupEntity
            :typeName "Content"
            :uuid id}
   [:... {:on :Content}
    content-fields]])

(x/def ^fragment content-mutation-fields {:on :ContentMutationPayload}
  [:content
   content-fields]
  [:contented
   q/entity-id-fields
   [:... {:on :Asset}
    [:primaryImage (q/image-link)]
    [:thumbnailImage {:gql/alias-of :primaryImage}
     (q/thumbnail-link)]]
   [:... {:on :Contented}
    [:contents
     q/entity-id-fields]]])

(x/defn ^mutation content-create! [{:keys [^ID! contentedId
                                           ^Boolean! curated
                                           ^String title
                                           ^String description
                                           ^URL! link
                                           ^ContentCategory! category]}]
  [:content_create
   {:contentedId contentedId
    :curated curated
    :title title
    :description description
    :link link
    :category category}
   content-mutation-fields])

(x/defn ^mutation content-update! [{:keys [^ID! id
                                           ^ID! contentedId
                                           ^String title
                                           ^String description
                                           ^URL! link]}]
  [:content_update
   {:id id
    :contentedId contentedId
    :title title
    :description description
    :link link}
   content-mutation-fields])

(x/defn ^mutation content-delete! [{:keys [^ID! id]}]
  [:content_delete
   {:id id}
   content-mutation-fields])


;; ========== Asset ==========

(x/defn ^query asset [{:keys [^UUID! id]}]
  [:entity {:gql/alias-of :lookupEntity
            :typeName "Asset"
            :uuid id}
   asset-fields])

(x/defn ^query asset-contents [{:keys [^UUID! id]}]
  [:entity {:gql/alias-of :lookupEntity
            :typeName "Asset"
            :uuid id}
   [:... {:on :Asset}
    q/entity-id-fields
    asset-alert-fields
    [:contents content-fields]
    [:contentsCurated {:gql/alias-of :contents
                       :recursive true
                       :curated true} content-fields]
    [:model
     :manufacturerSupportPhone
     :manufacturerSupportWebsite
     [:products
      q/entity-id-fields
      :name
      :description
      [:primaryImage (q/image-link)]
      [:thumbnailImage {:gql/alias-of :primaryImage}
       (q/thumbnail-link)]
      [:retailLinks :retailer :link]]]]])

(x/defn ^query system-status []
  [:systemStatus :message])

(x/def ^fragment asset-mutation-fields {:on :AssetMutationPayload}
  [:asset asset-fields]
  [:assetGroup
   asset-group-name-fields
   [:assets q/entity-id-fields]])

(x/defn ^mutation asset-create! [{:keys [^ID! assetGroupId
                                         ^String manufacturer
                                         ^String modelNumber
                                         ^URL nameplateLink
                                         ^URL imageLink
                                         ^String nickname
                                         ^String serialNumber
                                         ^String tagName]}]
  [:asset_create {:assetGroupId assetGroupId
                  :manufacturerName manufacturer
                  :modelNumber modelNumber
                  :nameplateLink nameplateLink
                  :imageLink imageLink
                  :nickname nickname
                  :serialNumber serialNumber
                  :tagName tagName}
   asset-mutation-fields])

(x/defn ^mutation asset-update! [{:keys [^ID! id
                                         ^ID assetGroupId
                                         ^String manufacturer
                                         ^String modelNumber
                                         ^URL nameplateLink
                                         ^String nickname
                                         ^String serialNumber
                                         ^String tagName
                                         ^String transcriptionComment
                                         ^Boolean requestTranscription]}]
  [:asset_update {:id id
                  :assetGroupId assetGroupId
                  :manufacturerName manufacturer
                  :modelNumber modelNumber
                  :nameplateLink nameplateLink
                  :nickname nickname
                  :serialNumber serialNumber
                  :tagName tagName
                  :transcriptionComment transcriptionComment
                  :requestTranscription requestTranscription}
   asset-mutation-fields])

(x/defn ^mutation asset-delete! [{:keys [^ID! id]}]
  [:asset_delete
   {:id id}
   [:asset asset-fields]
   [:assetGroup
    q/entity-id-fields
    [:assets
     q/entity-id-fields]]
   [:property
    [:assetGroups q/entity-id-fields]]])

;; ========== Asset Group ==========

(x/defn ^query asset-group-names [{:keys [^UUID! id]}]
  [:entity {:gql/alias-of :lookupEntity
            :typeName "Property"
            :uuid id}
   q/entity-id-fields
   [:... {:on :Property}
    [:assetGroups
     asset-group-name-fields
     asset-group-alert-fields]]])

(x/defn ^query asset-group* [{:keys [^UUID! id]}]
  [:entity {:gql/alias-of :lookupEntity
            :uuid id
            :typeName "AssetGroup"}
   [:... {:on :AssetGroup}
    asset-group-name-fields
    [:assets asset-fields]
    [:contents content-fields]]])

(s/def ::id string?)
(s/def ::asset-group-args (s/keys :req-un [::id]))

(defn asset-group [props]
  (let [valid-args? (not= ::s/invalid (s/conform ::asset-group-args
                                                 props))]
    (when-not valid-args?
      (web3.tracking.sentry/capture-exception
        (js/Error. (str "Invalid input:\n" (vector #_ex/expound-str ::asset-group-args props)))))

    (let [{:keys [id]} props]
      (if (contains? id :id)
        (do (log/warn "An object in place of id, monkeying with the props THIS IS BAD AND SHOULD BE FIXED")
            (asset-group* id))
        (asset-group* props)))))

(x/defn ^mutation asset-group-update! [{:keys [^ID! id
                                               ^String! name]}]
  [:assetGroup_update {:id id
                       :name name}
   [:assetGroup asset-group-name-fields]])

(x/defn ^mutation asset-group-create! [{:keys [^String! name
                                               ^ID! propertyId]}]
  [:assetGroup_create
   {:propertyId propertyId
    :name name}
   [:assetGroup
    asset-group-name-fields]
   [:property
    q/entity-id-fields
    [:assetGroups asset-group-name-fields]]])

(x/defn ^mutation asset-group-delete! [{:keys [^ID! id]}]
  [:assetGroup_delete
   {:id id}
   [:property
    q/entity-id-fields
    [:assetGroups asset-group-name-fields]]])

(x/defn ^query asset-alert-status [{:keys [^UUID! id]}]
  [:entity {:gql/alias-of :lookupEntity
            :typeName "Asset"
            :uuid id}
   [:... {:on :Asset}
    q/entity-id-fields
    :alertStatus]])

(x/defn ^mutation recall-status-update! [{:keys [^ID! id
                                                 ^RecallStatus! code]}]
  [:recall_statusUpdate
   {:id id
    :status code}
   [:recall
    recall-fields]])

(x/defn ^query all-assets [{:keys [^UUID! id]}]
  [:entity {:gql/alias-of :lookupEntity
            :typeName "Property"
            :uuid id}
   [:... {:on :Property}
    q/entity-id-fields
    [:assetGroups
     asset-group-name-fields
     [:assets
      asset-fields]]]])

(x/defn ^query search-models [{:keys [^String! brand
                                      ^String! model
                                      ^Int limit]}]
  [:searchModels {:manufacturerName brand
                  :modelNumber model
                  :limit limit}
   q/entity-id-fields

   ;; TODO: factor out this common set of Model attributes
   :number
   [:recalls
    q/entity-id-fields
    :title
    :description
    :match
    :url]
   [:encompassData :productCount :modelPageLink]
   :manufacturerSupportPhone
   :manufacturerSupportWebsite
   [:manufacturer :name]
   [:products
    q/entity-id-fields
    :name
    :description
    [:primaryImage (q/image-link)]
    [:thumbnailImage {:gql/alias-of :primaryImage}
     (q/thumbnail-link)]
    [:retailLinks :retailer :link]]
   [:contents {:curated true}
    content-fields]
   [:tags :name :homeAdvisorLink]
   [:primaryImage (q/image-link)]
   [:thumbnailImage {:gql/alias-of :primaryImage}
    (q/thumbnail-link)]])

(x/defn ^query related-models [{:keys [^String! brand
                                       ^String! model
                                       ^Int limit]}]
  [:searchModels {:manufacturerName brand
                  :modelNumber model
                  :limit limit}
   q/entity-id-fields
   [:tags :name]
   :number
   [:manufacturer :name]
   [:products q/entity-id-fields]
   [:contents {:curated true} :category]
   [:thumbnailImage {:gql/alias-of :primaryImage}
    (q/thumbnail-link)]])

(x/defn ^query model-lookup [{:keys [^UUID! id]}]
  [:model {:gql/alias-of :lookupModel
           :uuid id}
   q/entity-id-fields

   ;; TODO: factor out this common set of Model attributes
   :number
   [:recalls
    q/entity-id-fields
    :title
    :description
    :match
    :url]
   [:encompassData :productCount :modelPageLink]
   :manufacturerSupportPhone
   :manufacturerSupportWebsite
   [:manufacturer :name]
   [:products
    q/entity-id-fields
    :name
    :description
    [:primaryImage (q/image-link)]
    [:thumbnailImage {:gql/alias-of :primaryImage}
     (q/thumbnail-link)]
    [:retailLinks :retailer :link]]
   [:contents {:curated true}
    content-fields]
   [:tags :name :homeAdvisorLink]
   [:primaryImage (q/image-link)]
   [:thumbnailImage {:gql/alias-of :primaryImage}
    (q/thumbnail-link)]])


;; ========== 'Fetch' functions ==========
;;
;; Functions that wrap queries to provide cleaner argument/return-value semantics.
;;

(defn fetch-group
  [id]
  (some->> id
           (hash-map :id)
           (asset-group)
           :entity))

(defn fetch-asset
  [id]
  (some->> id
           (hash-map :id)
           (asset)
           :entity))

